<!--
 * @Author: 曹捷
 * @Date: 2021-10-27 09:55:41
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-11 15:46:31
 * @Description: 菜单
-->
<template>
  <div class="top-menu" v-if="dataList.length>0">
    <a-tabs class="" v-model:activeKey="activeKey" @change="tabChange">
      <a-tab-pane :key="item.name" :tab="item.title" v-for="item in dataList"></a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { reactive, toRefs } from '@vue/reactivity'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, watch } from '@vue/runtime-core'
import { useStore } from 'vuex'
import { util } from 'obit-wui'
import { pushState, historyData } from './../hook/history'
export default {
  props: {
    'menuList': {
      type: Array
    },
    type: {
      type: String
    }
  },
  setup (props, context) {
    let _data = reactive({
      activeKey: '2',
      dataList: []
    })
    let route = useRoute(), store = useStore(), router = useRouter()
    let config = store.state.settings
    let method = {
      sysyActiveKey () {
        let item = _data.dataList.find(el => el.path === window.location.pathname)
        if (item) {
          _data.activeKey = item.name
        }
      },
      isMainApp () {
        return route.path.indexOf('/main') === 0
      }
    }
    let _methods = {
      tabChange (activeKey) {
        let item = _data.dataList.find(el => el.name === activeKey)
        if (method.isMainApp()) {
          // 主应用 切换三级目录
          router.push({ path: item.path })
        } else {
          // 切换子应用三级菜单
          pushState(item[config.menu.url])
        }
      },
      initMenu (path) {
        path = path ? path : window.location.pathname
        // 主应用设置
        if (method.isMainApp()) {
          _data.dataList = [
            { title: '我的服务', path: '/main/set/myserver', name: 'myserver' },
            { title: '组织机构', path: '/main/set/org', name: 'org' },
            { title: '角色管理', path: '/main/set/role', name: 'role' },
            { title: '用户管理', path: '/main/set/user', name: 'user' },
          ]
        } else {
          let item = store.state.permission.menuList.find(el => el.path == path)
          let sysMenu = store.state.permission.sysMenu
          function getMenuList (list, key) {
            for (const i in list) {
              if (list[i].pId && list[i].selfId === key) {
                return list[i].children
              } else if (list[i].children && list[i].children.length > 0) {
                let res = getMenuList(list[i].children, key)
                if (res) return res
              }
            }
          }
          if (item) {
            let list = getMenuList(sysMenu, item.pId)
            list = list ? util.util.cloneObj(list) : []
            _data.dataList = list
          }
        }
      }
    }
    watch(() => historyData.url, (value) => {
      _methods.initMenu(value)
      method.sysyActiveKey()
    })
    watch(() => route.path, (value) => {
      _methods.initMenu()
      method.sysyActiveKey()
    })
    onMounted(() => {
      _methods.initMenu()
      method.sysyActiveKey()
    })
    return {
      ...toRefs(_data), ..._methods
    }
  }
}
</script>

<style lang="less">
.top-menu {
  height: 46px;
  background: @bodyBackColor;
  .ant-tabs-nav-wrap {
    padding-left: 32px;
  }
  .ant-tabs-bar {
    border-bottom: 1px solid @border;
  }
}
</style>
